<template>
  <div id="app">
    <nav class="navbar navbar-expand navbar-dark bg-dark flex-column">
      <a class="navbar-brand mx-auto" href="#">
        <img src="./assets/logo.png" alt="ARC LE SALON" height="36" />
      </a>
    </nav>

    <div class="container py-3">
      <router-view />
    </div>
    <footer class="footer bg-dark py-2 text-white-50">
      <div class="container text-center">
        <small
          >&copy; {{ new Date().getFullYear() }} ARC LE SALON. All rights
          reserved, Hunter & Gold Ltd.</small
        >
      </div>
    </footer>
  </div>
</template>

<script>
export default {};
</script>
<style>
.nav-bar-logo-centered .nav-bar-nav .nav-bar-link {
  padding: 0.5em 1em;
}

#footer {
  position: fixed;
  bottom: 0;
}
</style>

